import { useNavigate } from "react-router-dom";

export default function Quiz({ title, description, id }) {
  const navigate = useNavigate();

  const handelQuizWithId = () => {
    navigate(`/showQuiz/${id}`); // الانتقال إلى الصفحة الجديدة مع تمرير الـ id
  };

  return (
    <div className="quiz">
      <div className="quiz--continer">
        <div className="quiz--continer__content">
          <h3 className="quiz--continer__content-title">{title}</h3>
          <div className="quiz--continer__content-discription">
            <p className="quiz--continer__content-pragraph">{description}</p>
            <button
              onClick={handelQuizWithId}
              className="quiz--continer__content-button Btn"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}